import {EntityModel} from '../../../core/model/entity.model';
import {LocalDate, LocalTime} from '@js-joda/core';

export class WorkdayLogEntry extends EntityModel {

  public time?: LocalTime;
}
